<template>
    <section class="qrs-typography">
      <pageHeader>
        <h2 class="qrs-header-xl mt--0 mb--0">Help and support</h2>
      </pageHeader>

      <div>
        <a
        @click="goBack"
        class="govuk-back-link"
        role="button"
        aria-label="go back to the previous screen"
      >
        <strong>Previous</strong>
      </a>
      
        <ul>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/aberdeenshire-living-well-with-dementia/aberdeenshire-help-and-support/" target="_blank">Aberdeenshire - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/angus-living-well-with-dementia/angus-help-and-support/" target="_blank">Angus - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/inverclyde-living-well-with-dementia/inverclyde-help-and-support/" target="_blank">Inverclyde - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/living-well-with-dementia-for-everyone/" target="_blank">Living well with dementia - for everyone</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/orkney-living-well-with-dementia/orkney-help-and-support/" target="_blank">Orkney - Help and support</a>
          </li>
        </ul>
      </div>

    </section>
  </template>
  
  <script>
  export default {
    name: "helpAndSupport",
  
    data() {
      return {
      };
    },
    methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
        } else {
          if (url.includes("#")) {
            window.Native("dataCallback", url);
          }
          if (target == "_blank") {
            let data = { title: "", nodeid: dataId, href: url, target: target };
            window.Native("dataCallback", data);
          }
        }
      }
    },
    goBack() {
      this.$parent.goTo(this.$MyWellbeingDiary);
    },
  }

  };
  </script>